import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContactPerson, Contributor } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-contact-person-list',
  templateUrl: './contact-person-list.component.html',
  styleUrls: ['./contact-person-list.component.scss'],
})
export class ContactPersonListComponent implements OnInit, OnChanges {
  @Input() contactPersons?: (ContactPerson | Contributor)[];
  @Input() limit = 6;
  @Input() fairId: string | undefined = undefined;
  @Input() exhibitorId: string | undefined = undefined;
  @Input() exhibitorName: string | undefined = undefined;
  @Input() contactBaseLink: string | undefined = undefined;
  @Input() size: string | null | undefined = undefined;
  @Input() contactClickable = true;
  @Output() trackContactClick = new EventEmitter<{
    element: EventTarget | null;
    linkType: string;
    contactPersonId: string | undefined;
    linkText: string | undefined;
  }>();
  displayedContactPersons: ContactPerson[] = [];
  expandable = false;
  expanded = false;

  ngOnInit() {
    this.showLess();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contactPersons']) {
      this.showLess();
    }
  }

  showMore() {
    this.displayedContactPersons = [];

    if (this.contactPersons) {
      this.displayedContactPersons = this.contactPersons;
    }

    this.expanded = true;
  }

  showLess() {
    this.displayedContactPersons = [];

    if (this.contactPersons) {
      this.expandable = this.contactPersons.length > <number>(<unknown>this.limit);

      const loopEnd = !this.expandable ? this.contactPersons.length : <number>(<unknown>this.limit);

      for (let i = 0; i < loopEnd; i++) {
        this.displayedContactPersons.push(this.contactPersons[i]);
      }
    }

    this.expanded = false;
  }

  identifyContactPerson(_index: number, contactPerson: ContactPerson): string {
    return contactPerson.id;
  }
}
